<template>
  <div
    class="self box-border absolute py-4 px-12 border-solid border border-gray-300 flex justify-center items-center justify-around"
  >
    <div class="flex flex-col pr-5">
      <div class="text-xl font-medium mb-5">CATI云电话调查</div>
      <div class="text-base leading-tight mb-4">云端CATI电话调查，在线自动拨号，多坐席管理，通话状态跟踪，全过程录音</div>
      <div class="text-sm">在线自动拨号：调查APP在线自动拨号，对外显示固定座机号</div>
      <div class="text-sm">多坐席高效率：多个调查员可同时开展调查工作，便捷高效</div>
      <div class="text-sm">通话状态跟踪：呼叫通话状态实时掌握，历史数据协助管理统计</div>
      <div class="text-sm">通话全程录音：每份调查实时、全程录音，审核更便捷</div>
      <div class="text-xl mt-5 cursor-pointer show-detail" @click="toCATI">查看 CATI 云电话调查 功能详情 ></div>
    </div>
    <div class="bg-gray-300" style="height: 300px; width: 1px"></div>
    <div class="flex flex-col items-center flex-shrink-0 m-10">
      <div class="mb-1">打开微信，扫码联系开通</div>
      <div style="width: 200px; height: 200px">
        <img :src="baseUrl+'img/code/Mr.Huang.png'" style="width: 100%; height: 100%" />
      </div>
      <div
        class="self-end rounded-full border border-gray-800 border-solid py-1 px-4 mt-6 text-gray-800 cursor-pointer"
        @click="toCATI"
      >
        我知道了
      </div>
    </div>
  </div>
</template>

<script>
import { toSurveyBase } from '@/assets/js/base-platform.js'
export default {
  name: 'CATIComp',
  data() {
    return {}
  },
  methods: {
    toCATI() {
      toSurveyBase('/catiPhone')
    }
  }
}
</script>
<style lang="scss" scoped>
.self {
  width: 800px;
  @apply absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2;
  .show-detail {
    @apply text-theme;
  }
}
</style>
